import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as commonActions from '@common/common.action';
import WebapiCommon from '@common/util/webapi.common';
import LaudoPage from './laudo.page';
import LaudoApi from './laudo.api';
import IntlMessage from "../../helpers/intlMessage";

const LaudoContainer = props => {
  const dispatch = useDispatch();
  const { cdlaudo } = useParams();
  const altura = useSelector(state => state.commonReducer.altura);
  const etapa = useSelector(state => state.commonReducer.etapa);
  const detalhes = useSelector(state => state.commonReducer.detalhes);
  const listagem = useSelector(state => state.commonReducer.listagem);

  window.addEventListener('message-component', handlerEvent);
  window.addEventListener('keydown', updateAtalho);

  const handlerEvent = event => {

    if (
			event.data.key === 'RegisterMessage' &&
			event.data.value === 'EventShortcut'
		) {
			let args = undefined;
			let keyCode = event.data.args.keyCode;
			let keyCodeValid =
				(keyCode > 47 && keyCode < 91) ||
				(keyCode > 95 && keyCode < 106) ||
				(keyCode > 111 && keyCode < 124);

			if (keyCodeValid) {
				args = '';
				args += event.data.args.ctrKeyPress ? 'ctrl+' : '';
				args += event.data.args.altKeyPress ? 'alt+' : '';
				args += event.data.args.shiftKeyPress ? 'shift+' : '';
				args += event.data.args.key.toLowerCase();
			}
			this.props.commonActions.preencherAtalho(args);
		}
  }

  const updateAtalho = event => {
    console.log('ctrl+alt+',event);
    if (
      event.altKey &&
      event.key !== 'Alt' &&
      event.ctrlKey &&
      event.key !== 'Ctrl' &&
      this.props.detalhes
    ) {
      console.log('ctrl+alt+',event);
      this.props.actions.preencherAtalho('ctrl+alt+' + trim(event.key));
    }
  }

  useEffect(() => {
    dispatch(commonActions.atualizarDetalhes(null));
    obterLaudoParaDetalhes(cdlaudo);
    return () => {
      dispatch(commonActions.atualizarDetalhes(null));
    };
  }, [cdlaudo]);

  const obterLaudoParaDetalhes = laudoId => {
    dispatch(commonActions.showFadeCarregando(true));
    dispatch(commonActions.atualizarLaudoDetalhes(laudoId));

    if(!listagem || listagem.length===0) {
      LaudoApi.getLaudo(cdlaudo).then(response => {
        dispatch(commonActions.preencherListagem(response.listagem));
      })
    }

    if (!!listagem) {
      const laudo = listagem.find(l => l.laudo === Number(laudoId));
      if (laudo) {
        getLaudoDetalhes(laudo);
        dispatch(commonActions.atualizarLaudoSelecionado(laudo));
        return;
      }
    }

    LaudoApi.getLaudo(laudoId).then(resp => {
      if (resp) {
        const { listagem } = resp;
        if (listagem && listagem.length) {
          const [laudo] = listagem;
          getLaudoDetalhes(laudo);
          dispatch(commonActions.atualizarLaudoSelecionado(laudo));
        } else {
          dispatch(commonActions.showFadeCarregando(false));
          let msg = <IntlMessage id = "dashboards.reports.examNotFound"/>
          const tamanho = msg.length * 10 + 'px';
          dispatch(commonActions.showAlerta('alerta', msg, 3500, tamanho));
        }
      } else {
        dispatch(commonActions.showFadeCarregando(false));
      }
    });
  };

  const getLaudoDetalhes = item => {
    const { laudo, prontuario, etapas, exame, nenhumaEtapaAplicavel } = item;

    if (nenhumaEtapaAplicavel) {
      const msg = `O tipo de exame ${exame} não possui nenhuma etapa aplicável`;
      const tamanho = msg.length * 10 + 'px';
      dispatch(commonActions.showAlerta('alerta', msg, 3500, tamanho));
    } else {
      WebapiCommon.getDetalhes(laudo).then(response => {
        dispatch(
          commonActions.atualizarLaudoSelecionado({ laudo, prontuario, exame })
        );
        getQuantidadeLaudosAnteriores(prontuario);
        getQuantidadeLaudosEmAberto(prontuario, laudo);
        dispatch(commonActions.atualizarDetalhes({ ...response, etapas }));
        let index = listagem.findIndex(
          item => item.laudo === laudo
        );
        if (index>-1) {
          listagem[index] = { ...response, etapas }
          dispatch(commonActions.preencherListagem(listagem));
        }
        else
        {
          dispatch(commonActions.preencherListagem([{ ...response, etapas }]));
        }
        WebapiCommon.getHistoricoNaoConformidades(response.laudo).then(result =>
          dispatch(commonActions.preenhcerHistoricoInconformidades(result))
        );
      });
    }
  };

  const getQuantidadeLaudosAnteriores = prontuario => {
    WebapiCommon.getLaudosAnterioresQuantidade(prontuario).then(result => {
      dispatch(commonActions.preenhcerTotalLaudosAnteriores(result));
    });
  };

  const getQuantidadeLaudosEmAberto = (prontuario, laudo) => {
    WebapiCommon.getTotalExamesEmAberto(prontuario, laudo).then(result => {
      dispatch(commonActions.preencherTotalLaudosEmAberto(result));
    });
  };

  return (
    <LaudoPage
      laudoPageProps={{
        etapa,
        detalhes,
        altura,
        history: props.history
      }}
    />
  );
};

export default LaudoContainer;



// WEBPACK FOOTER //
// ./src/pages/laudo/laudo.container.js